import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { Video } from './../../../models/video.model';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-carrousel',
  templateUrl: './video-carrousel.component.html',
  styleUrls: ['./video-carrousel.component.scss']
})
export class VideoCarrouselComponent implements OnInit {
  @Input() videoList: Video[] = [];

  public config: SwiperConfigInterface = {
    a11y: { enabled: true },
    direction: 'horizontal',
    slidesPerView: 2,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      hideOnClick: false
    },
    centerInsufficientSlides: true
  };

  constructor(
  ) { }

  ngOnInit(): void {
    this.youtubeNoCookies();
  }

  youtubeNoCookies(): void {
    for (var i = 0; i < this.videoList.length; i++) {
      var video = this.videoList[i].video.toString();
      if (!video.includes('youtube-nocookie')){
        video = video.replace('youtube', 'youtube-nocookie');
        this.videoList[i].video = video;
      }
    }
  }
}
